import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { Tooltip } from '@mui/material';
import { Schedule as ScheduleIcon } from '@mui/icons-material';

import EventOptionsMenu from '../EventOptionsMenu';
import { isLongSessionWorkout } from '../../../../../../../utils/longSession';
import {
  DraftContainer,
  DraftTitle,
  DraftIconButton,
  ScheduleIconWrapper,
} from './styles';
import texts from './texts.json';

/**
 * A workout a scheduled assignment is going to write when it fires, rendered on
 * the calendar as a draft the coach can still edit (S2-7706).
 */
const ScheduledDraftEventContent = ({
  draft,
  scheduledForText,
  onEditDraft,
}) => {
  /*
    Same reason EventContent hides Edit on a long session, and one step worse here: the editor
    opens on the draft's stored content rather than the workout document, and saving writes
    `preparedActivities` into payload.workoutOverrides — which for a long session would replace
    the server-written video activity with a mount-time snapshot of it. The draft still shows;
    it just cannot be edited.
  */
  const canEdit = !isLongSessionWorkout(draft.workoutContent);

  return (
    <DraftContainer>
      <Tooltip
        title={format(draft.isEdited ? texts.editedTooltip : texts.tooltip, {
          name: draft.workoutContent?.name,
          scheduledFor: scheduledForText,
        })}
        arrow
      >
        <ScheduleIconWrapper>
          <ScheduleIcon />
        </ScheduleIconWrapper>
      </Tooltip>
      <DraftTitle onClick={canEdit ? () => onEditDraft(draft) : undefined}>
        {draft.workoutContent?.name}
      </DraftTitle>
      {canEdit && (
        <EventOptionsMenu
          TriggerButton={DraftIconButton}
          ariaLabel={format(texts.optionsLabel, { name: draft.workoutContent?.name })}
          options={[
            {
              label: texts.edit,
              onClick: (close) => {
                close();
                onEditDraft(draft);
              },
            },
          ]}
        />
      )}
    </DraftContainer>
  );
};

ScheduledDraftEventContent.propTypes = {
  draft: PropTypes.object.isRequired,
  scheduledForText: PropTypes.string,
  onEditDraft: PropTypes.func.isRequired,
};

ScheduledDraftEventContent.defaultProps = {
  scheduledForText: '',
};

export default ScheduledDraftEventContent;
